import { blogAppDefId } from '../constants/apps';
import type { PlatformApi } from '../controller/platform-api';

const getSectionUrl = (sectionId: string) => async (platformApi: PlatformApi) => {
  const result = await platformApi.site.getSectionUrl({
    sectionId,
    appDefinitionId: blogAppDefId,
  });

  return result.url || '';
};

export const getBlogFeedSectionUrl = getSectionUrl('blog');
export const getBlogPostPageSectionUrl = getSectionUrl('post');
